import request from '@/utils/request'
import URL from './urlTranslator'

// 根据业务类型获取业务跟踪状态配置
export function trackingListByLob(lob) {
  return request({
    url: URL.sys.trackingListByLob,
    method: 'get',
    params: { lob }
  })
}
// 获取指定模板的节点及节点状态列表
export function getListByTemplateKey(params) {
  return request({
    url: URL.sys.getListByTemplateKey,
    method: 'get',
    params
  })
}
// 获取指定业务的预警节点状态uuid列表
export function getPendingListByJobUuid(params) {
  return request({
    url: URL.sys.getPendingListByJobUuid,
    method: 'get',
    params
  })
}

// 获取job的业务节点
export function getTrackingNodeByJobUuid(jobUuid) {
  return request({
    url: URL.seaExport.getTrackingNodeByJobUuid,
    method: 'get',
    params: { jobUuid }
  })
}

// 获取job的业务状态跟踪
export function getTrackingInfoByJobUuid(jobUuid) {
  return request({
    url: URL.seaExport.getTrackingInfoByJobUuid,
    method: 'get',
    params: { jobUuid }
  })
}

// 新增Job的业务状态
export function saveTrackingNode(data) {
  return request({
    url: URL.seaExport.saveTrackingNode,
    method: 'post',
    data
  })
}

// 删除Job的业务状态
export function deleteTrackingNode(jobUuid, trackuuid) {
  return request({
    url: URL.seaExport.deleteTrackingNode + '?jobUuid=' + encodeURIComponent(jobUuid) + '&trackuuid=' + encodeURIComponent(trackuuid),
    method: 'delete'
  })
}

// 删除业务状态
export function delTrackingNode(trackUuid) {
  return request({
    url: URL.seaExport.delTrackingNode,
    method: 'delete',
    params: { trackUuid }
  })
}

// 保存Job的业务状态
export function saveTrackingInfo(data) {
  return request({
    url: URL.seaExport.saveTrackingInfo,
    method: 'post',
    data
  })
}
// 保存Job的业务状态
export function changeJobSopTemplate(params) {
  return request({
    url: URL.seaExport.changeJobSopTemplate,
    method: 'get',
    params
  })
}
// 批量更新业务sop模板
export function batchChangeJobSopTemplate(data, params) {
  return request({
    url: URL.seaExport.batchChangeJobSopTemplate,
    method: 'post',
    params,
    data
  })
}

// 更新外部状态
export function updateExternalTracking(data) {
  return request({
    url: URL.seaExport.updateExternalTracking,
    method: 'post',
    data
  })
}

// 获取模板
export function getTemplateByUuid(tempUuid) {
  return request({
    url: URL.sys.getTemplateByUuid + '?tempUuid=' + encodeURIComponent(tempUuid),
    method: 'get'
  })
}

// 获取模板内容
export function rptWebService(templateFile, schemaType, jobUuid) {
  return request({
    url: URL.seaExport.rptWebService + '?templateFile=' + encodeURIComponent(templateFile) + '&schemaType=' + encodeURIComponent(schemaType) + '&jobUuid=' + encodeURIComponent(jobUuid),
    method: 'get'
  })
}

// 获取发送邮件的正文
export function getEmailContent(jobUuid, code) {
  return request({
    url: URL.seaExport.getEmailContent + '?jobUuid=' + encodeURIComponent(jobUuid) + '&code=' + encodeURIComponent(code),
    method: 'get'
  })
}

// 根据获取SOP操作状态弹窗数据源
export function getSopStates(body) {
  return request({
    url: URL.sys.getSopStates,
    method: 'get',
    params: body
  })
}

// 更新并触发Sop节点
export function updateTrackingEvent(body) {
  return request({
    url: URL.sys.updateTrackingEvent,
    method: 'get',
    params: body
  })
}

// 同步至小票
export function syncTrackingInfoToSlaveJob(body) {
  return request({
    url: URL.sys.syncTrackingInfoToSlaveJob,
    method: 'get',
    params: body
  })
}

